module.exports = __webpack_public_path__ + "img/index-pro-02.1bd85495.jpg";